export function isGatewayContact(receiver) {
    return receiver.id.startsWith('*');
}
export function isEchoContact(receiver) {
    return receiver.id === 'ECHOECHO';
}
